import React from "react";
import { Badge, Icon, SxProps, Theme } from "@mui/material";
import SvgIcon from "@mui/material/SvgIcon/SvgIcon";

export interface IVpMenuIconBadgeProps {
    selected: string;
    badgeValue: number | undefined;
    icon: string | typeof SvgIcon;
    iconStyle?: SxProps<Theme>;
}

export const VpMenuIconBadge = (props: IVpMenuIconBadgeProps) => {
    return <Badge badgeContent={props.badgeValue} className={`menu-badge ${props.selected}`} max={9999} showZero={props.badgeValue !== undefined}>
        {typeof props.icon === "string" ?
            <Icon className={`menu-badge ${props.selected}`} data-testid={props.icon}>
                {props.icon}
            </Icon> :
            <Icon className={`menu-badge ${props.selected}`} data-testid={props.icon.muiName}>
                <props.icon sx={props.iconStyle} />
            </Icon>}
    </Badge>;
};
